import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'kui-snackbar-item',
    templateUrl: 'snackbar-item.component.html',
    styleUrls: ['snackbar-item.component.scss'],
})
export class KuiSnackbarItemComponent {
    @Input() icon: string;
    @Input() title: string;
    @Input() description: string;
    @Input() actionText: string;
    @Input() duration: number;

    @Output() onActionClicked = new EventEmitter<void>();
    @Output() onClosed = new EventEmitter<void>();

    startStopAnimation(e: MouseEvent) {
        (e.target as HTMLDivElement).style.animation = this.getAnimation(e.type === 'mouseleave' && this.duration);
    }

    getAnimation(duration: number): string {
        return !!duration ? 'fadeout ' + duration / 1000 + 's ease-in 2s forwards' : 'none';
    }
}
